import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=f578b6fe&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=f578b6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f578b6fe",
  null
  
)

export default component.exports